import { SectionCard } from "./SectionCard";
import { FooterText } from "./FooterText";

const ReferralsTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS AND CONDITIONS – REFERRAL REWARDS
        </h2>
        <p className="text-muted mt-2">
          Read the terms below to learn more about the Kegow referral reward
          program.
        </p>
      </header>

      <div>
        <SectionCard
          title="1. Program Overview"
          items={[
            "1.1 The referral reward program is offered by Kegow to encourage users to refer friends, family and business associates/partners/networks to download and use Kegow for transactions.",
            "1.2 By participating in the program, you agree to be bound by these terms and conditions, as well as the Kegow's general Terms of Service and Privacy Policy.",
          ]}
        />

        <SectionCard
          title="2. Eligibility"
          items={[
            "2.1 To be eligible for participation in the program, you must be a registered and active user of Kegow.",
          ]}
        />

        <SectionCard
          title="3. Referral Process"
          customContent={
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                3.1 Users can refer friends and family to download Kegow using a
                unique referral link that will be provided to each user.
              </li>
              <li className="mb-2">
                3.2 The referrer should be an active customer who has done at
                least one transaction within the last 3 months and must have a
                minimum balance of &#8358;1000 in his or her wallet to qualify
                for the award.
              </li>
              <li className="mb-2">
                3.3 Users can refer friends and family to download Kegow using a
                unique referral link that will be provided to each user.
              </li>
              <li className="mb-2">
                3.4 The referee should credit his or her wallet with a minimum
                of &#8358;1000 to earn the award.
              </li>
              <li className="mb-2">
                3.5 &#8358;500 to be shared between the referrer and the
                referee. Referrer gets &#8358;250, Referee gets &#8358;250.
              </li>
              <li className="mb-2">
                3.6 Rewards will be credited to the commission wallet so that
                they can only use it to buy electricity, airtime, data or cable
                TV.
              </li>
              <li className="mb-2">
                3.7 The referee should credit his or her wallet with a minimum
                of &#8358;1000 to earn the award.
              </li>
              <li className="mb-2">3.8 Promo ends July 31st.</li>
              <li className="mb-0">
                3.9 To qualify for the referral reward, the referrer must ensure
                that referrals register and successfully complete all required
                onboarding steps.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="4. Referral Rewards"
          items={[
            "4.1 Referral rewards will be deposited into the referrer's commission wallet within a reasonable timeframe once the referee meets the eligibility criteria.",
          ]}
        />

        <SectionCard
          title="5. Limitations"
          items={[
            "5.1 Referral rewards may be subject to change or discontinuation at any time without prior notice.",
          ]}
        />

        <SectionCard
          title="6. Compliance"
          items={[
            "6.1 Users must comply with all applicable laws and regulations when participating in the program, including but not limited to anti-spam laws and regulations.",
            "6.2 Users must not engage in fraudulent and deceptive practices, including but not limited to creating fake accounts or using automated methods to generate referrals.",
          ]}
        />

        <SectionCard
          title="7. Termination"
          items={[
            "7.1 Kegow reserves the right to terminate or suspend the program or any user's participation in the program at any time for any reason without liability.",
          ]}
        />

        <SectionCard
          title="8. Modification of Terms"
          items={[
            "8.1 Kegow reserves the right to modify these terms and conditions at any time without prior notice. Continued participation in the program after any such modifications shall constitute acceptance of the modified terms.",
          ]}
        />

        <SectionCard
          title="9. Contact Information"
          customContent={
            <div>
              <p className="mb-0">
                9.1 If you have any concerns or questions about the program,
                please contact us by writing to us at{" "}
                <a
                  href="mailto:support@kegow.com"
                  className="text-decoration-none fw-bold"
                >
                  support@kegow.com
                </a>{" "}
                (the subject of the email should be "Referral Reward System") or
                call 08079664791.
              </p>
            </div>
          }
        />
        <SectionCard
          title="10. Entire Agreement"
          customContent={
            <div>
              <p className="mb-3">
                10.1 These terms and conditions constitute the entire agreement
                between the user and Kegow regarding the program and supersede
                all prior and contemporaneous agreements and understandings.
              </p>
              <p className="mb-0 fw-bold">
                By participating in this program, you acknowledge that you have
                read, understood, and agree to be bound by these terms and
                conditions.
              </p>
            </div>
          }
        />
        <FooterText
          supportText="For inquiries or customer support, please contact Kegow customer
            service through the official app channels."
          termsText="
              This referral reward program is valid until July 31st. Kegow
              reserves the right to verify referrals, revoke rewards in cases of
              suspected fraud, and modify program terms. Rewards are credited to
              commission wallets and can only be used for specified services.
              Participation indicates agreement to all terms and conditions."
        />
      </div>
    </div>
  );
};

export default ReferralsTermsAndConditions;
